<template>
  <el-container class="modelad_main">
    <!-- <el-header :height="'70'">
      <home-header :issearch=false :opacity="opacity"></home-header>
    </el-header> -->
    <el-main class="beforeloginmain">
      <!-- <search-andselect v-if="scrollsearch" class="searchandselect1" :style="{'top':topvalue}"></search-andselect> -->
      <search-andselect class="searchandselect"></search-andselect>
      <el-carousel
        trigger="click"
        height="auto"
      >
        <el-carousel-item
          :id="'item' + index"
          v-for="(item, index) in m4carousel"
          :key="index"
        >
          <a
            class="bannerLinkad"
            :href="item.link_url"
          >
            <img
              :src="item.photo1"
              alt=""
            >
          </a>
        </el-carousel-item>
      </el-carousel>
    </el-main>
    <!-- <el-footer
      v-if="hidefooter"
      style="height:316px"
    >
      <home-footer></home-footer>
    </el-footer> -->
    <el-footer v-if="hidefooter" :style="{'height': (webID == '111142' ? '120px' : '316px')}">
      <help-footer v-if="webID == '111142'"></help-footer>
      <home-footer v-else></home-footer>
    </el-footer>
  </el-container>
</template>
<script>
import helpFooter from "../components/helpFooter.vue"; //底部
import homeFooter from "../components/homeFooter.vue"; //底部
import homeHeader from "../components/homeHeader.vue"; //头部
import homeHeaderAd from "../components/homeHeaderAd.vue"; //头部
import homeFooterAd from "../components/homeFooterAd.vue"; //底部
import searchAndselect from "../components/searchAndselect"; //搜索框
import { mapGetters, mapActions } from "vuex";
import {
  getModuleInfo,
  getModulStyle,
  getResource,
  getCategoryNode
} from "./../services/api.js";
export default {
  components: {
    homeFooter,
    homeHeader,
    homeHeaderAd, //广告头
    homeFooterAd, //广告底
    searchAndselect, //搜索框
    helpFooter
  },
  data() {
    return {
      select: "",
      moduleIds: [15],
      m4carousel: [],
      opacity: "0.68",
      scrollsearch: false,
      topvalue: "0px"
    };
  },
  mounted() {
    // this.getMInfo();
    // this.goAllClass();
    // window.addEventListener("scroll", this.mosewheel, true);
  },
  watch: {
    curModelInfo: {
      handler(newval, oldval) {
        console.log("新频道id", newval);
        console.log("旧频道ID", oldval);
        this.getMInfo();
        this.goAllClass();
      },
      immediate: true,
      deep: true
    },
    // channel_id(newval, oldval) {
    //   console.log("新频道id", newval);
    //   console.log("旧频道ID", oldval);
    //   this.getMInfo();
    //   this.goAllClass();
    // }
  },
  computed: {
    ...mapGetters([
      "webModels",
      "curModelInfo",
      "modelsInfo",
      "webID",
      "hidefooter"
    ]),
    channel_id() {
      console.log(this.curModelInfo);
      // debugger;
      return this.curModelInfo.id;
      //return this.modelsInfo.filter(item => item.tpl_id == 10)[0].id;
    }
  },
  methods: {
    ...mapActions([
      "setExample",
      // "setCurModelInfo",
      "setWebModels"
    ]),
    async getGroupsDataByCategoryChangeV(item) {
      var obj = {
        review_state: 1 + "",
        search_type: 2 + "",
        // online_state: 1 + "",
        customer_id: this.webid,
        group_id: item.body9
      };
      if (item.body10 == "1") {
        let resul = await getResource(obj, 2);
        console.log(resul.data);
        // debugger;
        return {
          photo1: resul.data
            ? this.getCarouselShowImgUrl(resul.data.data[0])
            : "",
          link_url: `/search?isEnglish=false&type=1&text=&group_id=${item.body9}`,
          title: resul.data ? resul.data.data[0].group_title : ""
        };
      } else if (item.body10 == "2") {
        let resul = await getCategoryNode({
          customer_id: this.webid,
          category_id: item.body9
        });
        return {
          photo1: resul.data
            ? this.getCarouselShowImgUrl_Category(resul.data[0])
            : "",
          link_url: `/intopic?category=${item.body9}&text=${
            resul.data ? resul.data[0].cname : ""
          }&bigimg=${resul.data ? resul.data[0].index_image : ""}`,
          title: resul.data ? resul.data[0].cname : ""
        };
      } else if (item.body10 == "3") {
        return {
          photo1: item.promotion_cover,
          link_url: `/spread?promotion=${item.promotion_pic}`,
          title: "推广页"
        };
      }
    },
    getCarouselShowImgUrl_Category(item) {
      if (item.custom_index_image) {
        if (item.custom_index_image["1920x800"]) {
          return item.custom_index_image["1920x800"];
        }
      }
      return item.index_image;
    },
    getCarouselShowImgUrl(item) {
      if (item.group_custom_index_image) {
        if (item.group_custom_index_image["1920x800"]) {
          return item.group_custom_index_image["1920x800"];
        }
      }
      return item.group_index_image;
    },

    mosewheel(event) {
      let scrolltop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
      if (scrolltop == 0) {
        this.opacity = "0.68";
      } else {
        this.opacity = "1";
      }
      if (scrolltop > 70) {
        this.scrollsearch = true;
        this.topvalue = `${scrolltop + 70}px`;
      } else {
        this.scrollsearch = false;
      }
    },
    goAllClass() {
      // var bl = sessionStorage.getItem("user")
      //   ? JSON.parse(sessionStorage.getItem("user"))
      //   : false;
      // if (bl) {
      //   this.$router.push({
      //     path: "/allclassad"
      //   });
      // }
    },
    getMInfo() {
      let data = {
        module_id: 16, //轮播图的module_id始终固定为16
        web_id: this.webID,
        use_sort_num: 1,
        channel_id: this.channel_id //this.curModelInfo.id //频道id
      };
      console.log("this.channel_id", data)
      getModuleInfo(data).then(async res => {
        if (res.status_code == 1) {
          this.m4carousel = res.data.list;
          for (let i = 0; i < this.m4carousel.length; i++) {
            let resul = await this.getGroupsDataByCategoryChangeV(
              this.m4carousel[i]
            );
            this.m4carousel[i].photo1 = resul.photo1;
            this.m4carousel[i].link_url = resul.link_url;
            this.m4carousel[i].title = resul.title;
            this.$set(this.m4carousel, i, this.m4carousel[i]);
          }
        }
      });
    }
  }
};
</script>
<style lang="less">
.beforeloginmain {
  background-color: #181a1a;
}
.modelad_main {
  .searchandselect1 {
    position: absolute;
    z-index: 99;
    left: 200px;
    right: 200px;
  }
  .searchandselect {
    position: absolute;
    z-index: 99;
    left: 50%;
    // right: 200px;
    top: 223px;
    width: 900px;
    margin-left: -450px;
  }
  .el-header {
    background-color: white;
  }
  .el-main {
    padding: 0px 0px;
    min-height: 300px;
    .el-carousel {
      width: 100%;
      height: 100%;
      .el-carousel__container {
        // height: 100%;
        width: 100%;
        height: auto !important;
        #item0 {
          position: relative !important;
          // top:4px;
        }
        .el-carousel__item {
          display: block;
        }
        // .is-active{
        //   position: relative !important;
        // }
      }
    }
  }
  .el-footer {
    padding: 0px;
  }

  .bannerLinkad {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/page/modelAdBeforeLogin.vue